import { useAppStore } from '@store'
import { motion } from 'framer-motion'
import { useEffect } from 'react'

type SpinnerProps = {
  msg: string
}

export function Spinner({ msg }: SpinnerProps) {
  const t = useAppStore.use.t()
  const o = useAppStore.use.openModal()
  const c = useAppStore.use.closeModal()
  useEffect(() => {
    o()
    return () => c()
  }, [o, c])
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className='pointer-events-none'
    >
      {/* Capa de fondo con opacidad, detrás de todo */}
      <div className='white-background fixed inset-0 z-40' />

      {/* Caja del spinner, sin white-background, por encima */}
      <div
        aria-label='Loading...'
        role='status'
        className='flew-row absolute left-1/2 top-1/2 z-50 flex h-[146px] w-[1000px] -translate-x-1/2 -translate-y-1/2 items-center justify-evenly space-x-2 border-4 border-colorAtemporal bg-white px-8 py-8'
      >
        <svg
          className='ml-4 mr-6 h-16 w-16 animate-spin stroke-colorAtemporal'
          viewBox='0 0 256 256'
        >
          <line
            x1='128'
            y1='32'
            x2='128'
            y2='64'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='195.9'
            y1='60.1'
            x2='173.3'
            y2='82.7'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='224'
            y1='128'
            x2='192'
            y2='128'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='195.9'
            y1='195.9'
            x2='173.3'
            y2='173.3'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='128'
            y1='224'
            x2='128'
            y2='192'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='60.1'
            y1='195.9'
            x2='82.7'
            y2='173.3'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='32'
            y1='128'
            x2='64'
            y2='128'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='60.1'
            y1='60.1'
            x2='82.7'
            y2='82.7'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
        </svg>
        <span className='flex-grow text-center text-2xl font-medium text-C/Color3'> {t(msg)}</span>
      </div>
    </motion.div>
  )
}
